import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { WhatsAppFloating } from "../components/WhatsApp";
import { Button } from "../components/ui/button";
import { useSeo } from "../seo";

export const PageLayout = ({ path, eyebrow, title, intro, children, testId }) => {
  useSeo(path);
  useLayoutEffect(() => {
    const html = document.documentElement;
    const prev = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    html.style.scrollBehavior = prev;
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main data-testid={testId}>
        <section className="bg-gradient-to-b from-brand-50 to-white border-b border-brand-100">
          <div className="max-w-5xl mx-auto px-6 pt-14 pb-12">
            {eyebrow && (
              <div className="text-[12px] tracking-[0.3em] uppercase text-accent2 font-semibold">{eyebrow}</div>
            )}
            <h1 className="mt-3 font-display text-[34px] md:text-[44px] lg:text-[52px] leading-[1.1] font-extrabold text-brand-900">
              {title}
            </h1>
            {intro && <p className="mt-5 text-brand-700 text-base md:text-lg leading-relaxed max-w-3xl">{intro}</p>}
          </div>
        </section>
        <div className="max-w-5xl mx-auto px-6 py-14">{children}</div>
        <section className="bg-brand-900 text-white">
          <div className="max-w-5xl mx-auto px-6 py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
            <div>
              <h2 className="font-display text-2xl md:text-3xl font-extrabold">Lassen Sie uns über Ihre WEG sprechen.</h2>
              <p className="mt-2 text-brand-200">Kostenlos, unverbindlich und mit festem Ansprechpartner.</p>
            </div>
            <Button asChild className="bg-accent2 hover:bg-accent2/90 text-brand-900 rounded-full h-12 px-6 font-semibold shrink-0">
              <Link to="/#contact" data-testid="page-cta-contact">
                Unverbindliches Angebot anfragen <ArrowRight className="w-4 h-4 ml-2" />
              </Link>
            </Button>
          </div>
        </section>
      </main>
      <Footer />
      <WhatsAppFloating />
    </div>
  );
};

export const Section = ({ title, children }) => (
  <section className="mt-12 first:mt-0">
    <h2 className="font-display text-[24px] md:text-[30px] font-bold text-brand-900 mb-4">{title}</h2>
    {children}
  </section>
);

export const Text = ({ children }) => (
  <p className="text-brand-700 leading-relaxed mb-4 text-[15px] md:text-base">{children}</p>
);

export const Bullets = ({ items }) => (
  <ul className="grid sm:grid-cols-2 gap-3 mb-4">
    {items.map((it) => (
      <li key={it} className="flex items-start gap-2.5 rounded-xl border border-brand-100 bg-brand-50/40 px-4 py-3 text-[15px] text-brand-800">
        <span className="mt-2 w-1.5 h-1.5 rounded-full bg-accent2 shrink-0" />
        {it}
      </li>
    ))}
  </ul>
);
